/* eslint-disable no-script-url */

import React, { ReactElement } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LoadingOverlay from 'react-loading-overlay'
import { Modal, Backdrop, Box } from '@material-ui/core'
import { Clear } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  loadingOverlay: {
    position: 'absolute',
    height: '100%',
    width: '100%'
  },
  clearIcon: {
    fontSize: '26px',
    cursor: 'pointer'
  }
}))

const DefaultModal: React.FC<{
  children?: ReactElement
  open: boolean
  onClose: () => void
  loading?: boolean
}> = ({ children, open, onClose, loading = false, ...others }) => {
  const classes = useStyles({})
  return (
    <Modal
      open={open}
      className={classes.modal}
      BackdropComponent={Backdrop}
      closeAfterTransition
      BackdropProps={{
        timeout: 500
      }}
      onClose={onClose}
    >
      <React.Fragment>
        {loading && (
          <LoadingOverlay
            active={loading}
            spinner
            className={classes.loadingOverlay}
            styles={{
              overlay: base => ({
                ...base,
                background: 'rgba(255, 255, 255)',
                opacity: 0.4
              }),
              spinner: base => ({
                ...base,
                width: '100px',
                '& svg circle': {
                  stroke: '#3f51b5'
                }
              })
            }}
          />
        )}
        <Box position="relative">
          <Box position="absolute" top={5} right={5}>
            <Clear className={classes.clearIcon} onClick={onClose} color="primary" />
          </Box>
          {children}
        </Box>
      </React.Fragment>
    </Modal>
  )
}

export default DefaultModal
